import { render } from "./statusArchiveApplic.vue?vue&type=template&id=37fe9912"
import script from "./statusArchiveApplic.vue?vue&type=script&lang=js"
export * from "./statusArchiveApplic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__